import { useState } from "react";
import { ShieldCheck, ShieldAlert, CircleAlert, CircleCheck } from "lucide-react";

export function ComplianceChip({ data, testId, large }) {
  const [tip, setTip] = useState(null);
  if (!data) return null;
  const { score, gaps } = data;
  const tone = score >= 80 ? "bg-[#E8F5E9] text-[#2E7D32]" : score >= 50 ? "bg-[#FFF3E0] text-[#B84A00]" : "bg-[#FFEBEE] text-[#C62828]";
  const bar = score >= 80 ? "bg-[#2E7D32]" : score >= 50 ? "bg-[#E65100]" : "bg-[#C62828]";
  const Icon = score >= 80 ? ShieldCheck : ShieldAlert;
  return (
    <span className="relative inline-flex">
      <span data-testid={testId}
        onMouseEnter={(e) => { const r = e.currentTarget.getBoundingClientRect(); setTip({ left: r.left + r.width / 2, top: r.bottom + 8 }); }}
        onMouseLeave={() => setTip(null)}
        className={`inline-flex shrink-0 cursor-help items-center gap-1 rounded-full font-bold ${tone} ${large ? "px-2.5 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]"}`}>
        <Icon size={large ? 13 : 10} /> {score}%
      </span>
      {tip && (
        <span className="pointer-events-none fixed z-[140] w-72 -translate-x-1/2 rounded-2xl border border-[#EFEBE0] bg-white p-4 text-left shadow-[0_16px_48px_-12px_rgba(62,39,35,0.35)]"
          style={{ left: tip.left, top: tip.top }}
          data-testid={testId ? `${testId}-tooltip` : undefined}>
          <span className="flex items-center justify-between">
            <span className="font-heading text-sm font-bold text-[#3E2723]">Chart Compliance</span>
            <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${tone}`}>{score}%</span>
          </span>
          <span className="mt-2 block h-1.5 w-full overflow-hidden rounded-full bg-[#F1EEE7]">
            <span className={`block h-full rounded-full ${bar}`} style={{ width: `${score}%` }} />
          </span>
          <span className="mt-1 block text-[10px] text-[#84675B]">Demographics · Consent · Treatment plan · Intake</span>
          {gaps.length === 0 ? (
            <span className="mt-3 flex items-start gap-2 text-xs text-[#2E7D32]">
              <CircleCheck size={13} className="mt-0.5 shrink-0" />
              <span className="font-semibold">Chart complete. Demographics, consent, treatment plan, and intake are all current.</span>
            </span>
          ) : (
            <span className="mt-3 block space-y-1.5">
              <span className="block text-[10px] font-bold uppercase tracking-[0.08em] text-[#C62828]">Gaps to close ({gaps.length})</span>
              {gaps.map((g, i) => (
                <span key={i} className="flex items-start gap-2 text-xs text-[#5D4037]">
                  <CircleAlert size={12} className="mt-0.5 shrink-0 text-[#B84A00]" /> {g}
                </span>
              ))}
            </span>
          )}
          <span className="mt-3 block border-t border-[#F1EEE7] pt-2 text-[10px] text-[#84675B]">Score recalculates automatically as chart items are completed.</span>
        </span>
      )}
    </span>
  );
}
